interface IBookmarkEntry {
  title: string
  description: string
  href: string
}

const bookmarks: IBookmarkEntry[] = [
  {
    title: 'Kafka Infrastructura',
    href: 'https://gitlab.com/sennder/engineering-effectiveness/platform/kafka/kafka-infrastructura',
    description:
      'All Kafka message schema definitions, i.e. contracts for communication between all services.'
  },
  {
    title: 'Global decisions log',
    href: 'https://gitlab.com/sennder/cross-cutting/tech-global-decision-log',
    description:
      'ADR’s (Architecture Decision Records) and RFC’s (Requests For Comments) which affect the whole sennder development landscape; know the future!'
  },
  {
    title: 'Logistics Platform Offerings',
    href: 'https://sennder.atlassian.net/wiki/x/MgBb5g',
    description:
      'A collection of all the offerings that the Logistics Platform provides to the rest of the company.'
  }
]

export default bookmarks
